import type { TimingsFromPerformanceMark } from './index';

export const timings: TimingsFromPerformanceMark[] = [];
